<template>
  <el-dialog class="comp-reword-h-detail" :visible.sync="visible" :show-close="false">
    <template slot="title">
      <div class="dialog-title flex flex-between">
        <div class="lef flex">
          <span class="reword-post">岗位悬赏-{{ postTitle }}</span>
        </div>
        <i class="el-icon-close close-btn" @click="close"></i>
      </div>
    </template>

    <div class="table-box">
      <div class="table-tit flex">
        <span class="tit">岗位悬赏历史明细</span>
        <span class="total">{{ `共${tableTotal}条` }}</span>
      </div>
      <el-table :data="tableData" style="width: 100%; height: 400px; overflow-y: auto;">
        <el-table-column prop="code" label="悬赏任务编号" min-width="265" />
        <el-table-column prop="typeCN" label="范围" width="120" />
        <el-table-column prop="singleAmount" label="单次佣金" width="100" />
        <el-table-column prop="updatedAt" label="浏览时间" width="200" />
        <el-table-column prop="startAt" label="上线时间" width="200" />
        <el-table-column prop="amount" label="预算设置" width="100" />
        <el-table-column prop="overspendCN" label="超支设置" width="100" />
        <el-table-column prop="count" label="累计派发数" width="120" />
        <el-table-column prop="expenseAmount" label="累计金额(元)" width="120" />
      </el-table>
      <el-pagination
        v-if="tableTotal > 0"
        class="flex flex-end"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="tableTotal">
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      id: {
        type: [String, Number],
        default: ''
      },
      postTitle: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        visible: false,
        currentPage: 1,
        pageSize: 10,
        tableTotal: 0,
        tableData: [],
      }
    },
    watch: {
      show: {
        handler(val) {
          this.visible = val
          if (val) {
            this.getTableData()
          }
        },
        immediate: true
      }
    },
    methods: {
      getTableData() {
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          recruitId: this.id
        }
        this.axios.post(`/wapi/hr/recruit/page/reward`, params).then(res => {
          console.log('res--', res)
          if (res.code === 200) {
            this.tableData = res.rows.map(f => ({
              ...f,
              typeCN: f.type === 1 ? '全体转发' : '精准转发',
              overspendCN: f.overspend === 1 ? '超支' : '不超支'
            }))

            this.tableTotal = res.total
          }
        })
      },
      close() {
        this.$emit('update:show', false)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        this.getTableData()
      },
    },
  }
</script>

<style lang="less" scoped>
@import '~@/assets/less/base.less';

.comp-reword-h-detail {
  /deep/ .el-dialog {
    width: 1052px;
    background: linear-gradient(133deg, rgba(212, 236, 254, 1) 0%, rgba(255, 255, 255, 1) 100%);
    border-radius: 12px;
    .dialog-title {

      .close-btn {
        font-size: 12px;
        color: #333333;
        cursor: pointer;
        font-weight: 500;
      }
      .reword-post {
        font-weight: bold;
        font-size: 24px;
        color: rgba(0,0,0,0.85);
        line-height: 28px;
        margin-right: 10px;
      }
      .status {
        height: 24px;
        border-radius: 4px;
        padding: 0 8px;
        line-height: 24px;
        color: rgba(255, 255, 255, 1);
        &.s-on {
          background: linear-gradient( 90deg, #69A1FF 0%, #82E1FF 100%);
        }
        &.s-end {
          background: linear-gradient( 270deg, #FF8254 0%, #FF3B4B 100%);
        }
      }
    }
    .el-dialog__header {
      padding: 30px 40px 0 40px;
    }
    .el-dialog__body {
      padding: 15px 40px 40px 40px;
    }
    .info-box {
      margin-bottom: 16px;
      font-size: 16px;
      color: #040F24;
      line-height: 22px;
    }
    .reword-no:first-child {
      margin-right: 74px;

    }
    .warn {
      font-size: 12px;
      color: #FF7D00;
      line-height: 17px;
      .el-icon-warning {
        margin-right: 4px;
      }
    }
    .btn-warn {
      border-color: rgba(255, 77, 79, 1);
      color: rgba(255, 77, 79, 1);
    }
    .warn-btns {
      margin-bottom: 14px;
    }

    .block-item {
      width: 186px;
      height: 71px;
      background: #FFFFFF;
      border-radius: 4px;
      padding: 10px 0 0 12px;
      &:not(:last-child) {
        margin-right: 10px;
      }
      .icon-img {
        width: 36px;
        height: 36px;
        margin-right: 8px;
      }

      .text-box {
        .label {
          font-size: 12px;
          color: #4E5969;
          line-height: 17px;
          margin-bottom: 4px;
        }
        .value {
          font-size: 16px;
          color: #141414;
          line-height: 22px;
          font-weight: bold;
        }
      }
    }

    .table-box {
      width: 972px;
      max-height: 464px;
      background: #FFFFFF;
      border-radius: 7px;
      padding: 17px 24px;
      margin-top: 10px;
      .table-tit {
        margin-bottom: 8px;
        .tit {
          font-weight: bold;
          font-size: 16px;
          color: #040F24;
          line-height: 22px;
        }
        .total {
          font-size: 12px;
          color: rgba(85,85,85,0.75);
          line-height: 17px;
          margin-left: 6px;
        }
      }
    }

    .el-pagination {
      margin-top: 10px;
    }
    .el-table__header-wrapper thead div{
      background: #eef1f6;
      color: #1f2d3d;
    }

    .confirm-box {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 9999;
    }
    .confirm-dialog {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 432px;
      height: 186px;
      background: #FFFFFF;
      border-radius: 2px;
      .title {
        height: 44px;
        line-height: 44px;
        text-align: center;
        font-weight: 500;
        font-size: 18px;
        color: #2B2B2B;
        border-bottom: 1px solid rgba(232, 232, 232, 1);
      }
      .close-btn {
        position: absolute;
        right: 18px;
        top: 14px;
        font-size: 12px;
        color: #333333;
        cursor: pointer;
      }
      .confirm-content {
        font-size: 14px;
        color: #606266;
        line-height: 24px;
        padding: 21px 24px 0 24px;
      }
      .dialog-footer {
        margin-top: 16px;
        .el-button {
          width: 92px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// HistoryDetail.vue?138cbc0d